import * as types from "./types";

import API from "../utils/API";
import { isLocalAPI } from "../utils/utils";

import store from '../store';

export const tryFetchComplications = () => dispatch => {
    const {
        auth: {
            access_token,
        },
        complications: {
            list,
            listLoaded,
        }
    } = store.getState();

    if (listLoaded) {
        return Promise.resolve(list);
    }
    dispatch({ type: types.COMPLICATIONS_FETCH_REQUESTED });
    return API.request({
        path: isLocalAPI ? "/complications" : "/dap-hcp-patient/api/v1/customers/patients/complications",
        queryParams: {
            pagination: false,
            active: true
        },
        token: access_token
    })
    .then(response => {
        dispatch({ type: types.COMPLICATIONS_FETCH_SUCCESS, data: response["hydra:member"] });
        return response["hydra:member"];
    })
    .catch(error => dispatch({ type: types.COMPLICATIONS_FETCH_FAILURE, data: error }));
}
